import React, { useRef, useEffect } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { getEntryId } from "../utils/trackingUtils";

const SortableTableRow = ({ entry, children, isDragDisabled = false, onKeyDown }) => {
    const rowRef = useRef(null);
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: getEntryId(entry),
        disabled: isDragDisabled,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    useEffect(() => {
        if ((entry.isEditing || entry.tempId) && rowRef.current) {
            rowRef.current.focus();
        }
    }, [entry.isEditing, entry.tempId]);

    const handleRef = (node) => {
        rowRef.current = node;
        setNodeRef(node);
    };

    return (
        <tr ref={handleRef} style={style} {...attributes} onKeyDown={onKeyDown} tabIndex={onKeyDown ? 0 : undefined}>
            {!isDragDisabled && (
                <td className="entry-custom-order" {...listeners} style={{ display: "table-cell" }}>
                    <DragIndicatorIcon fontSize="small" style={{ color: "#999" }} />
                </td>
            )}
            {children}
        </tr>
    );
};

export default React.memo(SortableTableRow);
